import { Component, Element, forceUpdate, getAssetPath, h, Host, State } from '@stencil/core';

import wcShared from '@web-components/shared';

import avatarsBotClass from '../utils/avatars-bot.class';
import helpdeskCommon from '../utils/HelpdeskCommon.class';
import { FaqsStore } from '../utils/Stores/faqs-store';
import { InitStore } from '../utils/Stores/init-store';
import { SectionStore } from '../utils/Stores/section-store';
import { Store } from '../utils/Stores/store';

@Component({
  tag: 'module-helpdesk-component',
  styleUrl: 'main-helpdesk.scss',
  shadow: true,
})
export class ModuleHelpdesk {
  @Element() el: HTMLModuleHelpdeskComponentElement;

  @State() canBeDisplayed = true;
  @State() visibility = true;
  @State() contact_event = false;
  @State() hideIconHelpdesk = true;

  componentWillLoad() {
    if (!window['WC_MODULES_COMMON'].includes('helpdesk')) {
      this.canBeDisplayed = false;
      return null;
    }
    wcShared.displayComponent('helpdesk');

    avatarsBotClass.initAvatar();

    // TEST ONLY : FORCE FULL MODE AND REPORT ABUSE
    // Store?.set('is_full', true);
    // Store?.set('is_report_abuse', true);
    // window['CHATBOT_FULL'] = true;
    // window['CHATBOT_CALLMEBACK'] = true

    if (window['CHATBOT_REPORT_ABUSE']) {
      Store?.set('is_report_abuse', true);
    }

    if (window['CHATBOT_CALLMEBACK']) {
      Object.keys(SectionStore?.get('section')).map((item: IWCContextClose) => {
        SectionStore?.set('section', {
          ...SectionStore?.get('section'),
          [item]: item === 'contact_callmeback',
        });
      });
    }

    // Check if Heldpesk need to be run on full screen mode
    if (window.innerWidth > 768) {
      if (window['CHATBOT_FULL']) {
        Store?.set('is_full', true);
        this.visibility = false;
      }
      Store?.set('isMobile', false);
    } else {
      if (window['CHATBOT_FULL']) {
        this.visibility = false;
      }
      Store?.set('is_full', false);
      Store?.set('isMobile', true);
    }

    // Add hidden at the body when we are on mobile
    window.addEventListener('resize', (event: Event) => {
      if ((event.target as Window).innerWidth < 768 && !this.visibility) {
        document.body.style.overflowY = 'hidden';
        Store?.set('is_full', false);
        Store?.set('isMobile', true);
      } else {
        Store?.set('is_full', window['CHATBOT_FULL']);
        Store?.set('isMobile', false);
        document.body.style.overflowY = 'auto';
      }

      helpdeskCommon.hasScroll();
    });

    document.addEventListener('displayHelpdeskModule', (event: CustomEvent<boolean>) => {
      this.hideIconHelpdesk = event.detail;
    });

    // Retrocompatibility with the old support module.
    // Use to open an FAQ directly in helpdesk module.
    // Need to give in input ID of faq or IWCFaq
    document.addEventListener('openSupportModuleFaq', (event: CustomEvent<IWCFaq | number>) => {
      // Used to closing chatbot directly instead go back to chatbot
      Store?.set('isOpenFaqTrigger', true);

      if (event.detail === null) {
        FaqsStore?.set('current', null);
        FaqsStore?.set('faqs', { total: 0, faq: [] });
      } else if (typeof event.detail === 'number') {
        this.visibility = false;
        FaqsStore?.set('current', {
          id: event.detail,
          title: null,
          answer: null,
          url: null,
          nb_votes: null,
          short_url: null,
          services: null,
          has_voted: null,
          last_update: null,
        });
      } else {
        this.visibility = false;
        FaqsStore?.set('current', event.detail);
      }
      forceUpdate(this);
    });

    document.addEventListener('openSupportModule', async (event: CustomEvent) => {
      let eventDetail = event.detail;
      if (!eventDetail) {
        eventDetail = { opening: 'landing' };
      }

      // Used to closing chatbot directly instead go back to chatbot
      Store?.set('isOpenFaqTrigger', true);

      // Use to add data directly on mail, when custom event contain subject, description, ...
      Store?.set('contactEventData', {
        enabled: true,
        ...eventDetail,
      });

      Store?.set('messageData', {
        ...Store?.get('messageData'),
        service_slug: eventDetail.service_slug?.value,
        contact_type: eventDetail.contact_type?.value,
        lang: wcShared?.store?.utils?.getLang(),
        // sub_category: eventDetail?.sub_category?.value ? event.detail?.sub_category?.value : null,
        conversation_uuid: Store?.get('channel_id'),
        priority:
          eventDetail.service_slug?.value === 'jelastic' &&
          eventDetail.service_slug?.value === 'tech'
            ? null
            : false,
        email: Boolean(InitStore?.get('init')?.user?.email)
          ? InitStore?.get('init')?.user?.email
          : eventDetail.email?.value,
        subject: eventDetail?.subject?.value,
        description: eventDetail?.description?.value,
        partner_account: eventDetail?.partner_account?.value,
      });

      this.contact_event = !this.contact_event;

      let value = ['chat'];
      if (eventDetail.opening === 'faq') {
        value = ['faq_list'];
      } else if (eventDetail.opening === 'contact') {
        value = ['contact_list'];
      } else if (eventDetail.opening === 'landing') {
        value = ['landing'];
      } else if (eventDetail.opening === 'phone') {
        value = ['contact_phone'];
      } else if (eventDetail.opening === 'mail') {
        value = ['contact_mail'];
      } else if (eventDetail.opening === 'callmeback') {
        value = ['contact_callmeback'];
      } else if (eventDetail.opening === 'tickets') {
        value = ['tickets'];
      }

      // Switch section
      await Object.keys(SectionStore?.get('section')).map((item: IWCContextClose) => {
        SectionStore?.set('section', {
          ...SectionStore?.get('section'),
          [item]: value.includes(item),
        });
      });

      // Display chat
      this.visibility = false;

      forceUpdate(this);
    });
  }

  componentDidLoad() {
    window.dispatchEvent(new CustomEvent('moduleHelpdeskIsLoaded'));

    wcShared?.store?.addObserver('displayHelpdesk', (value) => {
      this.visibility = !value.display;
    });

    if (wcShared?.store?.utils?.getCookie('IkHelpdeskOpen') === 'true') {
      this.displayChat(true);
    }

    // Hook to go directly on contact mail when is it for Jelastic
    if (window.location.href.includes('jelastic=1')) {
      Store?.set('messageData', {
        ...Store?.get('messageData'),
        service_slug: 'jelastic',
        contact_type: 'tech',
        lang: wcShared?.store?.utils?.getLang(),
        priority:
          Store?.get('messageData')?.service_slug === 'jelastic' &&
          Store?.get('messageData')?.contact_type === 'tech'
            ? null
            : false,
      });

      // Switch section
      Object.keys(SectionStore?.get('section')).map((item: IWCContextClose) => {
        SectionStore?.set('section', {
          ...SectionStore?.get('section'),
          [item]: ['contact_mail_jelastic'].includes(item),
        });
      });
    }
  }

  private displayChat(value: boolean) {
    this.visibility = !value;
    wcShared?.store?.utils?.setCookie('IkHelpdeskOpen', value.toString(), 365);
  }

  render() {
    if (!this.canBeDisplayed) {
      return null;
    }

    return (
      <Host style={{ 'z-index': Store?.get('isMobile') ? '1000000' : '1000' }}>
        <div class={`theme-${wcShared?.store?.theme}`}>
          {window['HIDE_MODULE_SUPPORT'] ? null : (
            <div
              class={{
                helpdesk: true,
                'helpdesk--shop':
                  window['CURRENT_PROJECT'] === 'shop' || window['CURRENT_PROJECT'] === 'welcome',
                'helpdesk--full': window['CHATBOT_FULL'],
                hide: !this.hideIconHelpdesk,
              }}
            >
              <div class="helpdesk-icon">
                <div
                  onClick={() => {
                    this.displayChat(true);
                  }}
                  class={{ 'helpdesk-icon__support': true, hide: !this.visibility }}
                >
                  <img
                    class="helpdesk-icon__support--open"
                    src={getAssetPath('./../assets/icons/support.svg')}
                    alt={wcShared.translate("Besoin d'aide ?")}
                  />
                  <img
                    class="helpdesk-icon__support--close"
                    src={getAssetPath('./../assets/icons/white-cross.svg')}
                    alt={wcShared.translate('Fermer')}
                  />
                </div>
              </div>
            </div>
          )}
          {
            // DISPLAY CHATBOT
            !this.visibility ? (
              // DISPLAY FULL VERSION OF CHAT
              Store?.get('is_full') ? (
                <main-helpdesk-switch-component
                  contact_event={this.contact_event}
                  class="full"
                  style={{
                    background: `url(${getAssetPath(
                      './../assets/background/waves.svg',
                    )}) no-repeat center bottom, #163A96`,
                    'background-size': 'contain',
                  }}
                  faq={FaqsStore?.get('current')}
                >
                  <div slot="recaptcha-slot-2">
                    <slot name="recaptcha-slot" />
                  </div>
                </main-helpdesk-switch-component>
              ) : (
                // DISPLAY EMBED VERSION OF CHAT
                <main-helpdesk-switch-component
                  contact_event={this.contact_event}
                  faq={FaqsStore?.get('current')}
                >
                  <div slot="recaptcha-slot-2">
                    <slot name="recaptcha-slot" />
                  </div>
                </main-helpdesk-switch-component>
              )
            ) : null
          }
        </div>
      </Host>
    );
  }
}
